// Values of org.onboardingTodo. NULL means the todo is still shown.
export enum OnboardingTodoStatus {
  Completed = 'completed',
  Dismissed = 'dismissed',
}
